import { render, staticRenderFns } from "./dimension.vue?vue&type=template&id=1dabbf08&scoped=true&"
import script from "./dimension.vue?vue&type=script&lang=js&"
export * from "./dimension.vue?vue&type=script&lang=js&"
import style0 from "./dimension.vue?vue&type=style&index=0&id=1dabbf08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dabbf08",
  null
  
)

export default component.exports